import { render, staticRenderFns } from "./EmailAction.vue?vue&type=template&id=2823a8ac&scoped=true"
import script from "./EmailAction.vue?vue&type=script&lang=ts"
export * from "./EmailAction.vue?vue&type=script&lang=ts"
import style0 from "./EmailAction.vue?vue&type=style&index=0&id=2823a8ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823a8ac",
  null
  
)

/* custom blocks */
import block0 from "./EmailAction.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports